
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Dann stimmt entweder die Diagnose nicht – vielleicht auch, weil der Betroffene
seine Beschwerden nicht genügend protokolliert und dem Arzt damit die richtige
Diagnose erschwert hat. Oder das Medikament wurde zu spät genommen. Oder die
Dosis war zu niedrig. Oder das gewählte Mittel hilft diesem Menschen zu wenig.
Oder er hat etwas missverstanden. Allein das passive Hinlegen zur Akupunktur zum
Beispiel genügt nämlich nicht. Migräniker müssen selbst einiges tun, damit es
ihnen besser geht. Also zum Beispiel eine Arbeitspause einlegen, Handy
abschalten, nach draussen gehen und überhaupt den Alltag so gestalten, dass sie
«runterkommen» und die Wahrscheinlichkeit für eine Migräne möglichst reduzieren.
Dazu gehört auch genügend Schlaf.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;